import { makeAutoObservable } from 'mobx'
import { ViewColumnFragment, ViewColumnTemplateFragment } from 'types/graphql'

import { resolveColumnDisplayLabel } from 'src/models/TableViews/displayLabel'
import { TableViewColumnTemplateStore } from 'src/models/TableViews/TableViewColumnTemplateStore'

export class TableViewColumn {
  public readonly columnTemplateGeneratedId: string
  public displayIndex: number
  public displayLabelOverride: string | null

  private _columnTemplateStore: TableViewColumnTemplateStore

  constructor(args: {
    displayIndex: number
    columnTemplateStore: TableViewColumnTemplateStore
    columnGeneratedId: string
    displayLabelOverride?: string | null
  }) {
    this.columnTemplateGeneratedId = args.columnGeneratedId
    this._columnTemplateStore = args.columnTemplateStore
    this.displayIndex = args.displayIndex
    this.displayLabelOverride = args.displayLabelOverride ?? null
    makeAutoObservable(this)
  }

  /**
   * This can be null intermittently when deleting a custom column template
   */
  get columnTemplate(): ViewColumnTemplateFragment | undefined {
    return this._columnTemplateStore.columnTemplates.find(
      (ct) => ct.generatedId === this.columnTemplateGeneratedId
    )
  }

  /**
   * Live in-drawer header label. Falls back to the column template's
   * `labelTitleCase` when no override is set; falls back to the raw
   * generated id only when the column template hasn't loaded yet (rare
   * — the preview gates on `columnManager.columns` filtering out
   * template-less rows).
   */
  get displayLabel(): string {
    if (!this.columnTemplate) {
      return this.columnTemplateGeneratedId
    }
    return resolveColumnDisplayLabel(this.displayLabelOverride, this.columnTemplate)
  }

  public setDisplayLabelOverride(label: string | null) {
    this.displayLabelOverride = label
  }

  get protocol(): ViewColumnFragment {
    return {
      __typename: 'ViewColumn',
      columnTemplateGeneratedId: this.columnTemplateGeneratedId,
      displayLabelOverride: this.displayLabelOverride,
      displayLabel: this.displayLabel,
    }
  }
}
